/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum OrderServiceFailureReason {
    CarrierInfrequentPositionUpdates = 1,
    CarrierLatePickingUp = 2,
    CarrierLateDelivering = 3,
    CarrierDriverAppNotSetup = 4,
    TrackingLate = 5,
    TrackingNeedsCheckCall = 6,
    TrackingWaitingTime = 8,
    TrackingNeedsCustomerUpdate = 11,
    TrackingHCPodNeeded = 12,
    AccessorialApproval = 7,
    PaperworkTypeOverwritten = 9,
    PrintWithInvoiceOverwritten = 10,
    PaperworkMissing = 13,
    InvalidReferenceNumbers = 14,
    BillToVerificationFailed = 15,
    GeneralBillingFailure = 16,
    UnauthorizedAccessorials = 17,
}
